export default __webpack_public_path__ + "static/media/test1-slots.6510ae9a.png";